import apiClient from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchProfile = (id: string) => {
  return apiClient
    .get(`${BASE_URL}/admin_api/profiles/${id}/`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchTempProfiles = (id: string, page: number) => {
  return apiClient
    .get(`${BASE_URL}/admin_api/profiles/${id}/temp_profiles?page=${page}`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchTestRecords = (id: string, page: number) => {
  return apiClient
    .get(`${BASE_URL}/admin_api/profiles/${id}/test_records?page=${page}`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchTestRecord = (test_id: string, id: string) => {
  return apiClient
    .get(`${BASE_URL}/admin_api/profiles/${id}/test_records/${test_id}/`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const submitFactor = (factorData: FormData) => {
  return apiClient
    .post(`${BASE_URL}/admin_api/test-component/`, factorData)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};
